import { usePage } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';

export default function ImpersonationBanner() {
  const { t } = useTranslation();
  const { auth } = usePage().props;
  const impersonating = auth?.impersonating;

  if (!impersonating?.active) return null;

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-3 relative z-[9999]">
      <span>
        {t('nav.impersonating', { name: auth.user.full_name, role: auth.user.role, trueName: impersonating.true_user_name })}
      </span>
      <form action="/admin/users/stop_impersonating" method="post" className="inline">
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <button
          type="submit"
          className="underline font-semibold hover:text-amber-800 transition-colors"
        >
          {t('nav.stopImpersonating')}
        </button>
      </form>
    </div>
  );
}
